import { EntityMetadataBuilder, PropertyType, FetchType } from "clavis-nxt-components-custdevtm";
import {TranslationValueEntity} from "./TranslationValueEntity";

const METADATA = new EntityMetadataBuilder("TranslateForAdminEntity")
    .entityPath("translationForAdmin")
    .createProperty("id")
    .propertyType(PropertyType.STRING)
    .id()
    .finish()
    .createProperty("labelCode")
    .propertyType(PropertyType.STRING)
    .finish()
    .createProperty("moduleCode")
    .propertyType(PropertyType.STRING)
    .finish()
    .createProperty("translationValue")
    .propertyType(PropertyType.ENTITY)
    .fetchType(FetchType.FROM_DTO)
    .relatedProperty("id")
    .entityType(TranslationValueEntity)
    .finish()
    .build();

export default METADATA;
